import { render, staticRenderFns } from "./Interests.vue?vue&type=template&id=a5d094c8&scoped=true&"
import script from "./Interests.vue?vue&type=script&lang=js&"
export * from "./Interests.vue?vue&type=script&lang=js&"
import style0 from "./Interests.vue?vue&type=style&index=0&id=a5d094c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d094c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VContainer,VIcon,VProgressCircular})
